

import { Control, Controller, UseFormSetValue, UseFormWatch } from "react-hook-form";
import { UploadIcon, CheckCircledIcon } from "@radix-ui/react-icons";
import { Card, Flex,Text } from "@radix-ui/themes";
import { DragAndDropFileUpload } from "../../components/inputs/FileUpload/DragAndDropFileUpload";
import { useEffect } from "react";

 export type StudentPhotoUpload = {
  control: Control<any>;
  errors: any;
  setValue: UseFormSetValue<any>;
  watch: UseFormWatch<any>;
};

export const StudentPhotoUpload: React.FC<StudentPhotoUpload> = ({
  control,
  errors,
  setValue,
  watch,
}) => {
  const preview = watch("student.photoPreview");
  const uploaded = watch("student.photoUploaded");
 const fileValue = watch("student.photoFile");

  useEffect(() => {
if (preview) return;
    const f = fileValue;
    if (!f) return;

    if (typeof f === "string") {
      const str = f.startsWith("data:") ? f : `data:image/jpeg;base64,${f}`;
      setValue("student.photoPreview", str, { shouldValidate: false, shouldDirty: true });
      setValue("student.photoUploaded", true, { shouldValidate: false, shouldDirty: true });
      return;
    }

    if (f instanceof File) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const dataUrl = reader.result as string;
        setValue("student.photoPreview", dataUrl, { shouldValidate: false, shouldDirty: true });
        setValue("student.photoUploaded", true, { shouldValidate: false, shouldDirty: true });
      };
      reader.readAsDataURL(f);
    }
  }, [fileValue, preview, setValue]);



  const handleFileSelect = (file: File) => {
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setValue("student.photoPreview", reader.result as string, {
        shouldDirty: true,
      });
    };
    reader.readAsDataURL(file);

    setValue("student.photoFile", file, { shouldDirty: true });
    setValue("student.photoUploaded", true, { shouldDirty: true });
  };

  return (
    <Card style={{ padding: "20px", marginBottom: "16px" }}>
      <Flex direction="row" gap="4" align="start">
     
        <div
          style={{
            width: "150px",
            height: "150px",
            border: "2px dashed #ccc",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            backgroundColor: "#f9f9f9",
          }}
        >
          {preview ? (
            <img
              src={preview}
              alt="Foto do estudante"
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "cover",
              }}
            />
          ) : (
            <UploadIcon width="40" height="40" />
          )}
        </div>

        <Flex direction="column" gap="2" style={{ flex: 1 }}>
          <Text >
            Foto do estudante
          </Text>

          <Controller
  name="student.photoFile"
  control={control}
  render={({ field }) => (
    <DragAndDropFileUpload
      onFileDrop={(file) => {
        field.onChange(file);
        if (file) handleFileSelect(file);
      }}
                label="Arraste ou selecione a foto"
                selectedFile={field.value}
                accept="image/*"
              />
            )}
          />

          {errors?.student?.photoFile && (
            <Text color="red" size="1">
              {errors.student.photoFile.message as string}
            </Text>
          )}

          {uploaded && (
            <Flex align="center" gap="1">
              <CheckCircledIcon />
              <Text size="1">Foto pronta para envio com a matrícula</Text>
            </Flex>
          )}
        </Flex>
      </Flex>
    </Card>
  );
};

